module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fill-height": "",
      "container--fluid": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": _vm.breadCrumbsItems,
      "divider": ">"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('influencer-quality-rating', {
    attrs: {
      "theme": "#36a2eb",
      "title": _vm.INFLUENCER_RATING.title,
      "headers": _vm.influencerHeaders,
      "items": _vm.INFLUENCER_RATING.items,
      "filterCampaigns": _vm.filterCampaigns,
      "filterUsers": _vm.filterUsers
    },
    on: {
      "searchfilter": _vm.influencerSearch
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('client-quality-rating', {
    attrs: {
      "theme": "#36a2eb",
      "title": _vm.CLIENT_RATING.title,
      "headers": _vm.clientHeaders,
      "items": _vm.CLIENT_RATING.items,
      "filterCampaigns": _vm.filterCampaigns,
      "filterUsers": _vm.filterUsers,
      "filterUserLabel": "CC Filter"
    },
    on: {
      "searchfilter": _vm.clientSearch
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('pie-chart', {
    attrs: {
      "theme": "#36a2eb",
      "labels": _vm.REPORT_ABUSE.labels,
      "title": _vm.REPORT_ABUSE.title,
      "items": _vm.REPORT_ABUSE.items,
      "backgroundColors": _vm.REPORT_ABUSE.backgroundColors,
      "filterCampaigns": _vm.filterCampaigns,
      "filterUsers": _vm.filterUsers
    },
    on: {
      "searchfilter": _vm.reportAbuseSearch
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33f8a9b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/CODashboard/quality.vue
// module id = 2073
// module chunks = 0